import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Auth from "./Auth";
import getAccount from "../../controllers/user/getAccount";
import { logout, setUserData } from "../../redux/reducers/userSlice";
import LoadingBar from "../animation/LoadingBar";
import Logo from "../Logo/Logo";
import updateUserType from "../../controllers/user/updateUserType";
import getAgentByName from "../../controllers/user/getAgentByName";
import {
  domainList,
  getsubDomain,
  isCustomerSite,
} from "../../utils/getsubDomain";
import { getTestLevel } from "../../utils/testLevel";
import { setTemplate } from "../../redux/reducers/template/templateSlice";
import { CircularProgress } from "@mui/material";
import getCRMData from "../../controllers/crm/getCRMData";
import getFlightSetting from "../../controllers/settings/getFlightSetting";
import { setFlightSetting } from "../../redux/reducers/flight/flightSettingsSlice";
import { getRolesPermissions } from "../../controllers/settings/roles/getRolesPermissions";
import { setSettings } from "../../redux/reducers/settings/accountSettingsSlice";
import { getRoles } from "../../controllers/settings/roles/getRoles";


export default function AuthValidate() {
  const { userData } = useSelector((state) => state.user);
  const { loggedIn, user } = userData;

  const [stuck, setStuck] = useState(false);
  // sub domain test code
  // window.location.hostname.includes('.') ? window.location.hostname.split('.')[0] : null
  const [agencyName, setAgencyName] = useState(
    getsubDomain(window.location.href)
  );

  if (agencyName) {
    document.title = agencyName;
    const favicon = document.getElementById("favicon");
    if (favicon && userData?.agent?.detail?.agencyLogo) {
      favicon.href = userData?.agent?.detail?.agencyLogo;
    } else favicon.href = "abcd.com";
  } else {
    document.title = "Intraverse";
    const favicon = document.getElementById("favicon");
    favicon.href = "/logo.svg";
  }

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hash = queryParams.get("accept");
  const view = queryParams.get("view");

  const customer = isCustomerSite();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState({
    user: !agencyName || customer,
    agent: agencyName ? true : false,
  });

  const [lockUser, setLockUser] = useState(false);
  const [lockAgent, setLockAgent] = useState(false);
  const [lockCRMData, setLockCRMData] = useState(false);


  useEffect(() => {
    async function loadAgentAsync() {
      if (agencyName) await loadAgent();
    }

    loadAgentAsync();

    //eslint-disable-next-line
  }, []);


  useEffect(() => {
    if (!agencyName || customer) 
      if(!lockUser)
        loadUser();

    if(loggedIn && !customer)
      loadSettings();

    return () => setLockUser(false);
    // eslint-disable-next-line
  }, [loggedIn, userData?.refresh]);


  useEffect(() => {
    console.log('here crm loading')
    if(userData?.getCRM)
      if(userData?.agent?.token || userData?.accessToken)
        loadCRMData();

    return setLockCRMData(false);
    
    //eslint-disable-next-line
  }, [userData?.getCRM]);


  useEffect(() => {
    setTimeout(() => setStuck(true), 1000 * 60 * 2);

    // eslint-disable-next-line
  }, [user?.email, userData?.accessToken, userData?.refresh]);


  useEffect(() => {
    const script = document.createElement("script");
    const script2 = document.createElement("script");

    try {
      script.type = "text/javascript";
      script.type = "text/javascript";

      script.textContent = `
        // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/mqb9wn1p'
        (function(){
          var w=window;
          var ic=w.Intercom;
          if(typeof ic==="function"){
            ic('reattach_activator');
            ic('update',w.intercomSettings);
          }else{
            var d=document;
            var i=function(){i.c(arguments);};
            i.q=[];
            i.c=function(args){i.q.push(args);};
            w.Intercom=i;
            var l=function(){
              var s=d.createElement('script');
              s.type='text/javascript';
              s.async=true;
              s.src='https://widget.intercom.io/widget/mqb9wn1p';
              var x=d.getElementsByTagName('script')[0];
              x.parentNode.insertBefore(s,x);
            };
            if(document.readyState==='complete'){
              l();
            }else if(w.attachEvent){
              w.attachEvent('onload',l);
            }else{
              w.addEventListener('load',l,false);
            }
          }          
        })();
      `;
      if (getTestLevel() === getTestLevel("live"))
        script2.textContent = script2Content;

      if (getTestLevel() === getTestLevel("live")) {
        document.body.appendChild(script2);
        if (!customer) document.body.appendChild(script);
      }

      window?.Intercom("boot", {
        api_base: "https://api-iam.intercom.io",
        custom_launcher_selector: ".intercomButton",
        hide_default_launcher: true,
        app_id: "mqb9wn1p",
        name: `${user.firstName} ${user.lastName}`, // Full name
        email: `${user.email}`, // the email for your user
        created_at: `${user.createdAt}`, // Signup date as a Unix timestamp
      });
    } catch (ex) {}

    return () => {
      // document.body.removeChild(script);
    };

    // eslint-disable-next-line
  }, []);

  console.log("*", customer, agencyName, getTestLevel(),lockUser);

  async function loadSettings() {
    const res = await getFlightSetting();
    const res2 = await getRolesPermissions();
    const res3 = await getRoles();

    if(res?.return)
      dispatch(setFlightSetting(res?.data))
    if(res2?.return) {
      if(res3?.return) {
        const roles = res3?.data?.data || null;
        dispatch(setSettings({permissions: res2?.data,roles}));
      }
    }
  }
  
  async function loadUser() {
    setLockUser(true);
    setLoading((loading) => ({ ...loading, user: false }));
    if (!userData.accessToken || !userData?.loggedIn) {
      setLockUser(false);
      return null
    };

    setLoading((loading) => ({ ...loading, user: true }));
    const res = await getAccount();
    setLoading((loading) => ({ ...loading, user: false }));
    if (res.return) {
      if (!res?.data?.account?.userType && !customer) {
        const updRes = await updateUserType({ userType: "Agent" });
        if (updRes.return) {
          setLockUser(false);
          return dispatch(
            setUserData({ ...userData, refresh: false, user: updRes?.data, getCRM: true })
          );
        }
      }

      dispatch(
        setUserData({
          ...userData,
          refresh: false,
          getCRM: true,
          user: res?.data?.account,
          subscriptionPlan: res?.data?.subscriptionPlan,
        })
      );
    }
    setLockUser(false);
  }
  async function loadAgent() {
    if(lockAgent) return null;
    setLockAgent(true);

    setLoading((loading) => ({ ...loading, agent: true }));
    const res = await getAgentByName(agencyName);
    setLoading((loading) => ({ ...loading, agent: false }));
    console.log("agent load: ", res);
    if (res.return) {
      if (!userData?.loggedIn || !userData?.agent)
        dispatch(
          setUserData({
            ...userData,
            refresh: false,
            getCRM: true,
            agent: { ...res?.data, hash },
          })
        );
    } else if (res.msg === "Agent not found!")
      setAgencyName(agencyName + "!~~");
    else setAgencyName(getsubDomain(window.location.href) + "~~!");

    setLockAgent(false);
  }

  async function loadCRMData() {
    if (lockCRMData || (!userData?.loggedIn && !customer && !agencyName)) return null;
    setLockCRMData(true);
    
    let agentToken = userData?.agent?.token;
    const isCustomer = isCustomerSite();
    let fetchedCrmData = {};

    if (!isCustomer) {
      if (userData?.accessToken) {
        const crmResult = await getCRMData();
        if (crmResult.return) {
          fetchedCrmData = { ...(crmResult.data || {}) };
        }
      } else {
        console.warn("Not a customer site and no Intraverse token.");
      }
    } else if (isCustomer && agentToken) {
      const crmResult = await getCRMData();
      if (crmResult.return) {
        fetchedCrmData = { ...(crmResult.data || {}) };
      }
    } else if (isCustomer && !agentToken) {
      console.warn("Customer site without agent token.");
    }

    const mergedCrmData = { ...fetchedCrmData };
    dispatch(
      setUserData({
        ...userData,
        refresh: false,
        crmData: mergedCrmData,
        getCRM: false,
      })
    );
    if (!window?.location?.href?.includes("/preview/"))
      dispatch(setTemplate(JSON.parse(mergedCrmData?.templateData || "{}")));
    if (
      !window.location?.href?.includes("template") &&
      mergedCrmData?.templateData
    )
      dispatch(setTemplate(JSON.parse(mergedCrmData?.templateData) || "{}"));

      setLockCRMData(false);
  }

  const site =
    window.location.protocol +
    "//" +
    window.location.host.replace(agencyName?.replaceAll(".", "") + ".", "");
  // console.log(userData.loggedIn,userData?.agent?.hash,userData?.user)
  // console.log(site,agencyName)
  const authPage = view;

  if (domainList?.find((url) => window.location.hostname === url))
    return (
      <div className="flex justify-center">
        <div className="flex flex-col items-center justify-center gap-4 h-screen w-screen">
          <p>Oooops! - We don't have what you are looking for.</p>
          {/* <h5><a href={site} className='underline' >Sign in</a> to register with Intraverse.</h5> */}
        </div>
      </div>
    );

  return !loading?.agent && !loading?.user ? (
    <div className="flex justify-center">
      {agencyName?.includes("~~!") ? (
        <div className="flex flex-col items-center justify-center gap-4 h-screen w-screen">
          <h2>Network Error</h2>
          <p>
            Please{" "}
            <u
              className="cursor-pointer"
              onClick={() => window.location.reload()}
            >
              reload
            </u>
          </p>
        </div>
      ) : agencyName?.includes("!~~") ? (
        <div className="flex flex-col items-center justify-center gap-4 h-screen w-screen">
          <h2>Agency not found on the system</h2>
          <h5>
            <a href={site} className="underline">
              Sign in
            </a>{" "}
            to register with Intraverse.
          </h5>
        </div>
      ) : (
        <div className="max-w-full w-[1500px]">
          {loggedIn || (customer && !authPage) ? (
            user?._id || customer ? (
              <Outlet />
            ) : (
              <div className="flex flex-col gap-2 justify-center items-center h-screen w-full">
                <Logo />
                <LoadingBar />
                {stuck ? (
                  <div className="text-center">
                    <p>
                      It's taking too long. This might be a browser cache/cookie
                      problem.
                    </p>
                    <p>
                      If it's taking too long please &nbsp;
                      <button
                        onClick={() => dispatch(logout())}
                        className="underline"
                      >
                        {" "}
                        click here to logout
                      </button>
                    </p>
                  </div>
                ) : null}
              </div>
            )
          ) : (
            <Auth agency={agencyName} />
          )}
        </div>
      )}
    </div>
  ) : (
    <div className="flex items-center justify-center w-screen h-screen">
      <CircularProgress />
    </div>
  );
}

const script2Content = `
  !function(){var i="analytics",analytics=window[i]=window[i]||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","screen","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware","register"];analytics.factory=function(e){return function(){if(window[i].initialized)return window[i][e].apply(window[i],arguments);var n=Array.prototype.slice.call(arguments);if(["track","screen","alias","group","page","identify"].indexOf(e)>-1){var c=document.querySelector("link[rel='canonical']");n.push({__t:"bpc",c:c&&c.getAttribute("href")||void 0,p:location.pathname,u:location.href,s:location.search,t:document.title,r:document.referrer})}n.unshift(e);analytics.push(n);return analytics}};for(var n=0;n<analytics.methods.length;n++){var key=analytics.methods[n];analytics[key]=analytics.factory(key)}analytics.load=function(key,n){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.setAttribute("data-global-segment-analytics-key",i);t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var r=document.getElementsByTagName("script")[0];r.parentNode.insertBefore(t,r);analytics._loadOptions=n};analytics._writeKey="xmUlhOmT4jHXpLCBJ5Uhw9cu2VQwTqeK";;analytics.SNIPPET_VERSION="5.2.0";
  analytics.load("xmUlhOmT4jHXpLCBJ5Uhw9cu2VQwTqeK");
  analytics.page();
  }}();
`;